export const environment = {
  msalConfig: {
      auth: {
          clientId: '0d14a9b7-6ad8-4233-a269-bb63ce0746eb',
          authority: 'https://login.microsoftonline.com/b1e32279-3c8b-4c06-9279-43fd8b1c329b',
          redirectUri: '/',
          postLogoutRedirectUri: "/"
      },
      cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
        storeAuthStateInCookie: false, // set this to true if you have to support IE
    },
  },
  msalProtectedApis: {
    graphApi:{
      scopes: ['user.read'],
      endpoint: 'https://graph.microsoft.com/v1.0'
    },
    openAi: {
      scopes: ['api://44e86c53-60c7-4bb9-af82-75b909a7fcec/open.ai'],
      endpoint: 'https://app-openai-dev-swedcen-qk-001.azurewebsites.net'
    },
    webSocket: {
      scopes: ['api://44e86c53-60c7-4bb9-af82-75b909a7fcec/open.ai'],
      endpoint: 'wss://app-openai-dev-swedcen-qk-001.azurewebsites.net'
    }
  },
  graphConfig : {
      graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
      graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value'
  },
  requestUrls: {
    basicUrl : 'https://app-openai-dev-swedcen-qk-001.azurewebsites.net',
    keyPhrases: {
      getEndpoint: "/key_phrases",
      postEnpoint: "/key_phrases/edit_table",
      delete: "/key_phrases/delete_rows",
      webSocketKeyphraseUrl: 'wss://app-openai-dev-swedcen-qk-001.azurewebsites.net/key_phrases/ws',
    },
    topics: {
      getEndpoint: "/topic_clf",
      postEnpoint: "/topic_clf/edit_table",
      delete: "/topic_clf/delete_rows",
      webSocketTopicsUrl: 'wss://app-openai-dev-swedcen-qk-001.azurewebsites.net/topic_clf/ws'
    }
  }
}
